import { render, staticRenderFns } from "./PageOrphans.vue?vue&type=template&id=4ecabead&scoped=true&"
import script from "./PageOrphans.vue?vue&type=script&lang=js&"
export * from "./PageOrphans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecabead",
  null
  
)

export default component.exports